export default __webpack_public_path__ + "static/media/dashboard-bg-ingredients.37ac3b71.png";